import { dateStringSortFunction } from 'helpers/date';

export function sortProjectJobRoles<T extends { createdAt: string }>(projectJobRoles: T[], direction: 'asc' | 'desc' = 'desc'): T[] {
  return [...projectJobRoles].sort((a, b) => dateStringSortFunction(a.createdAt, b.createdAt, direction));
}